export enum SocketEventNameEnum {
  CAMPAIGN_ALL_MESSAGES_SCHEDULED = 'campaign-all-messages-scheduled',
  CAMPAIGN_PAUSED_STATUS_CHANGED = 'campaign-paused-status-changed',
  CONVERSATIONS_UNASSIGNED = 'conversations-unassigned',
  TEST_MESSAGE_INBOUND = 'test-message-inbound',
  TWO_WAY_CONVERSATION_UPDATED = 'two-way-conversation-updated'
}
